import React from 'react'
// import AddCourse from '../components/Instructor/AddCourse';
import Navbar from '../components/Navbar/Navbar';
import Assignments from '../components/courses/Assignments';




const AssignmentsPage = () => {
    return ( 
        <>
        <Navbar/>
        <Assignments/>
        </>
     );
}
 
export default AssignmentsPage;